import { Box, Button, CircularProgress, FormControl, IconButton, Modal, TextField, Typography } from '@mui/material';
import styles from './TransferToOfficeModal.module.css';
import CloseIcon from '@mui/icons-material/Close';
import OfficeTreeView from 'src/pages/Offices/components/OfficeTreeView';
import { useState } from 'react';
import { EmployeesService, GetOffice_Out, OfficeState, OfficesService } from 'src/pehra-ts-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TransferType } from 'src/pehra-ts-client/models/TransferType';
import { send } from 'process';
import useNotification from 'src/hooks/useNotification';

export interface ITransferToOfficeModal {
  openModal: boolean;
  handleCloseModal: () => void;
  employeesList: string[];
}

type TFormData = {
  parent_office_id: string | null;
  office_name: string;
};

const TransferToOfficeModal: React.FC<ITransferToOfficeModal> = ({ openModal, handleCloseModal, employeesList }) => {
  const [selectedOffice, setSelectedOffice] = useState<any>(null);

  const [sendNotification] = useNotification();
  const queryClient = useQueryClient();

  const transferToOffice = async () => {
    try {
      const res = await EmployeesService.transferEmployee({
        employee_ids: employeesList,
        office_id: selectedOffice.id,
        transfer_type: TransferType.TEMPORARY
      });
      return res;
    } catch (error) {
      throw error;
    }
  };

  const transferToOfficeMutation = useMutation({
    mutationFn: transferToOffice,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['employeesList']
      });
      sendNotification({
        msg: 'Employee Transferred Successfully',
        variant: 'success'
      });
      handleCloseModal();
    }
  });

  const handleTransferToOffice = () => {
    transferToOfficeMutation.mutate();
  };

  const modalContent = (
    <Box
      sx={{
        padding: '20px'
      }}
    >
      <Box></Box>
      <OfficeTreeView setSelectedOffice={setSelectedOffice} />
      <Box>{transferToOfficeMutation.isPending && <CircularProgress />}</Box>
      <Box
        sx={{
          marginTop: '50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Button
          variant="outlined"
          color="error"
          style={{ margin: '20px' }}
          onClick={() => {
            handleCloseModal();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: '20px' }}
          onClick={() => {
            handleTransferToOffice();
          }}
          disabled={!selectedOffice}
        >
          Transfer to {selectedOffice?.name} Office
        </Button>
      </Box>
    </Box>
  );

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box className={styles.modalContainer}>
        <IconButton onClick={handleCloseModal} style={{ position: 'absolute', right: '10px', top: '10px' }}>
          <CloseIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" style={{ padding: '20px' }}>
            Transfer to a Office
          </Typography>
        </Box>
        {modalContent}
      </Box>
    </Modal>
  );
};

export default TransferToOfficeModal;
